import { AlertTriangle } from "lucide-react";
import { akanHabis, sisaHariKontrak } from "@/lib/kontrak";

export default function KontrakHabisBadge({ kontrak, compact = false }) {
  if (!akanHabis(kontrak)) return null;
  const sisa = sisaHariKontrak(kontrak);
  const label = sisa === 0 ? "Habis hari ini" : `${sisa} hari lagi`;
  return (
    <span title={`Kontrak berakhir dalam ${sisa} hari — segera proses perpanjangan`} data-testid={`kontrak-akan-habis-${kontrak.id}`}
      className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-100 text-amber-800 border border-amber-300 font-bold ${compact ? "px-1.5 py-0 text-[9px]" : "px-2 py-0.5 text-[10px]"}`}>
      <AlertTriangle className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} />{label}
    </span>
  );
}
